import React, { useContext, useEffect, useState } from "react";
import DashboardLayout from "../../../layout/dashboard/DashboardLayout";
import TitleTextBox from "../../../fragments/TitleTextBox";
import {
  RavenBadge,
  RavenInputField,
  RavenNumberFormat,
  RavenRadioCheck,
} from "@ravenpay/raven-bank-ui";
import {
  Navigate,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { RouteLinks } from "../../../routes/RouteLinks";
import ContainerWrapper from "../../../fragments/ContainerWrapper";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/types";
import QuantitySelector from "../../../components/QuantitySelector";
import SwitchBox from "../../../components/SwitchBoxComponent";
import "../../../styles/dashboard/terminals/RequestTerminalsIndex.css";
import Icons from "../../../assets/icons/icons";
import {
  generateAccountNumber,
  getDeliveryLocations,
  getLocalGovernmentAreas,
  getRegions,
  requestTerminal,
  requestVirtualTerminal,
} from "../../../redux/insight";

import { reactSelectStyle } from "../../../helper";
import Skeleton from "react-loading-skeleton";
import { removeSpace } from "../../../utils/helpers";
import { log } from "console";
import RequestTerminalPreview from "./RequestTerminalPreview";
import { ThreeDots } from "react-loader-spinner";
import RequestVirtualTerminalPreview from "./RequestVirtualPreview";
import ActionContext from "../../../context/ActionContext";

const RequestTerminal = () => {
  const actionCtx = useContext(ActionContext);
  const stepList = ["Terminal Type", "Address Details", "Confirm Details"];
  const stepListTwo = ["Terminal Type", "Terminal Details", "Confirm Details"];
  const [step, setStep] = useState(1);
  const switchOptions = ["Deliver To Me", "Pick Up"];
  const [devicePrice, setDevicePrice] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const view = searchParams.get("view");

  const [topActiveOption, setTopActiveOption] = useState(
    view === "virtual" ? "Virtual Terminals" : "Physical Terminals"
  );
  const [requestDetails, setRequestDetails] = useState<any>({
    state: "",
    city: "",
    streetAddress: "",
    quantity: 1,
    pricePerOne: devicePrice,
    deliveryMethod: "",
    deliveryPickupId: "",
    days: "",
  });
  const [virtualTerminaldetails, setVirtualTerminalDetails] = useState<any>({
    terminalLabel: "",
    accountNo: "",
    purpose: "",
  });
  const formatState = (param: any) => {
    if (param?.length > 0) {
      const newList = param?.map((chi: any) => {
        return { label: chi, value: chi };
      });
      return newList;
    }
  };
  const {
    pickup_locations,
    loading_reciept,
    local_governmen_areas,
    regions,
    loading,
    loading_vir,
  } = useSelector((state: RootState) => state.insights);

  const topSwitchOptions = ["Physical Terminals", "Virtual Terminals"];

  const [activeOption, setActiveOption] = useState(switchOptions[0]);
  const [activePickUp, setActivePickup] = useState("");
  const location = useLocation();

  const purposeOfrequest = ["Agency Banking", "Merchant Collection"];

  const handleFetchLocations = async () => {
    const obj = {
      name: "",
    };
    const data = await dispatch(getDeliveryLocations(obj) as any);
    if (data.payload.status === "success") {
    }
  };

  const handleGenerateAccountNumber = async () => {
    const obj = {
      name: "",
    };

    const data = await dispatch(generateAccountNumber(obj) as any);

    if (data.payload.status === "success") {
      setVirtualTerminalDetails((prev: any) => ({
        ...prev,
        accountNo: data?.payload?.data?.data?.account_number,
      }));
    }
  };
  const handleGetLgas = async (param: any) => {
    const obj = {
      name: param?.value,
    };
    const data = await dispatch(getLocalGovernmentAreas(obj) as any);
    // console.log("this is data", data);

    if (data?.payload?.status === "success") {
      // console.log("iam lga", local_governmen_areas);
    }
  };
  const handleGetRegions = async () => {
    const obj = {
      name: "",
    };

    const data = await dispatch(getRegions(obj) as any);
    // console.log("this is data", data);

    if (data?.payload?.status === "success") {
      // console.log("iam lga", local_governmen_areas);
    }
  };

  const featuresObject = [
    {
      header: "Dedicated Account Number",
      text: "Get an account number dedicated to you.",
      icon: Icons.dedicatedUser,
    },
    {
      header: "Connected Alert Recievers",
      text: "Allow your cashiers receive notifications fast",
      icon: Icons.connectedAlerts,
    },
    {
      header: "Instant settlements",
      text: "See transaction settle in, real time",
      icon: Icons.flash,
    },
    {
      header: "Account Flier",
      text: "Generate a flier for your business.",
      icon: Icons.accountFlier,
    },
  ];

  useEffect(() => {
    if (Object?.keys(actionCtx?.configDetails)?.length > 0) {
      if (regions?.length < 1) {
        handleGetRegions();
      }

      if (pickup_locations?.length < 1) {
        handleFetchLocations();
      }
      setRequestDetails((prev: any) => ({
        ...prev,
        pricePerOne: actionCtx?.configDetails?.partnerInfo?.device_price,
      }));
    }
  }, [actionCtx?.configDetails]);

  const handleBtnStep = () => {
    if (topActiveOption === "Physical Terminals") {
      if (step < 3) {
        setStep(step + 1);
      }
      if (step === 3) {
        handleRequestPhysicalTerminal();
      }
    } else {
      if (step < 3) {
        setStep(step + 1);
      }
      if (step === 3) {
        handleRequestVirtualTerminal();
      }
    }
  };

  const handleDisableBtn = () => {
    if (topActiveOption === "Physical Terminals") {
      if (step === 1) {
        const val = requestDetails?.quantity < 1 ? true : false;
        return val;
      }
      if (step === 2 || step === 3) {
        if (activeOption === switchOptions[0]) {
          const val =
            !requestDetails?.city ||
            !requestDetails?.state ||
            !requestDetails?.streetAddress;
          return val;
        } else {
          const val = !activePickUp;
          return val;
        }
      }
      if (step === 3) {
      }
    } else {
      if (step === 1) {
        return false;
      }
      if (step === 2 || step === 3) {
        const val =
          !virtualTerminaldetails?.terminalLabel ||
          removeSpace(String(virtualTerminaldetails?.accountNo))?.length < 10 ||
          !virtualTerminaldetails?.purpose ||
          loading_reciept;
        return val;
      }
    }
  };

  function getValueAtIndex({
    array,
    index,
  }: {
    array: string[];
    index: number | string;
  }): string | null {
    if (Number(index) >= 0 && Number(index) < array.length) {
      return array[Number(index)];
    }
    return null; // or throw an error if preferred
  }

  const handleRequestPhysicalTerminal = async () => {
    // "quantity": 3,
    // "delivery_state": "Lagos", // add delivery address for home_delivery
    // "delivery_address": "the quad",
    // "delivery_lga": "Eti Osa",
    // "delivery_option": "home_delivery", // or pickup
    // "pickup_location_id": 2 // for pickup
    let val;
    if (activeOption === switchOptions[0]) {
      const obj = {
        quantity: requestDetails.quantity,
        delivery_state: requestDetails?.state?.value,
        delivery_address: requestDetails?.streetAddress,
        delivery_option: "home_delivery",
        delivery_lga: requestDetails?.city?.value,
      };
      val = obj;
    } else {
      const obj = {
        quantity: requestDetails.quantity,
        delivery_state: requestDetails?.state?.value,
        delivery_address: requestDetails?.streetAddress,
        delivery_option: "pickup",
        delivery_lga: requestDetails?.city?.value,
        pickup_location_id: requestDetails?.deliveryPickupId,
      };
      val = obj;
    }
    // console.log(val);
    // return;

    const data = await dispatch(requestTerminal(val as any) as any);

    if (data?.payload?.status === "success") {
      navigate(RouteLinks.AllRequested_Terminal);
    }
  };

  const handleRequestVirtualTerminal = async () => {
    const obj = {
      label: virtualTerminaldetails.terminalLabel,
      account_number: virtualTerminaldetails.accountNo,
      purpose: virtualTerminaldetails.purpose?.value,
    };
    const data = await dispatch(requestVirtualTerminal(obj as any) as any);
    if (data?.payload?.status === "success") {
      // navigate(RouteLinks.Terminals_Virtual);
      handleClearAllState();
      navigate(RouteLinks?.Terminal_Virtual_List);
    }
  };

  function sortDays(days: readonly string[]): string[] {
    const weekOrder = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    return [...days].sort(
      (a, b) => weekOrder.indexOf(a) - weekOrder.indexOf(b)
    );
  }

  function sortDaysToString(days: readonly string[]): string {
    const weekOrder = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const sorted = [...days]?.sort(
      (a, b) => weekOrder?.indexOf(a) - weekOrder?.indexOf(b)
    );
    return sorted?.join(", ");
  }

  const handleClearAllState = () => {
    setVirtualTerminalDetails({
      terminalLabel: "",
      accountNo: "",
      purpose: "",
    });
    setRequestDetails({
      state: "",
      city: "",
      streetAddress: "",
      quantity: 1,
      pricePerOne: devicePrice,
      deliveryMethod: "",
      deliveryPickupId: "",
      days: "",
    });
  };

  return (
    <DashboardLayout>
      <TitleTextBox
        title={`Request a  ${step === 1 ? "Terminals" : topActiveOption}`}
        onBack={() => {
          if (navigate?.length > 1) {
            navigate(-1);
          } else {
            navigate(RouteLinks?.Physical_Terminal_list);
          }
        }}
        back
        text="Power your business with a strong toolkit designed for growth"
      />
      {/* title end here -------------- */}
      <ContainerWrapper
        // dontShowHeader
        activeStep={step}
        back={step > 1}
        onBack={() => {
          if (step > 1) {
            setStep(step - 1);
          }
        }}
        stepList={
          topActiveOption === "Physical Terminals" ? stepList : stepListTwo
        }
        width={`100%`}
        noContentLoading={loading}
        btnText={
          step < 3
            ? (getValueAtIndex({
                array:
                  topActiveOption === "Physical Terminals"
                    ? stepList
                    : stepListTwo,
                index: step,
              }) as any)
            : "Request Terminal"
        }
        disabled={handleDisableBtn()}
        onBtnClick={handleBtnStep}
        loading={loading_vir}
      >
        <div
          // onClick={() => {
          //   console.log(actionCtx?.configDetails);
          // }}
          className="request-terminal-general-wrap"
        >
          {step === 1 && (
            <div className="top-switch-box-component">
              <SwitchBox
                options={topSwitchOptions}
                active={topActiveOption}
                setActive={(param) => {
                  handleClearAllState();
                  setTopActiveOption(param);
                }}
              />
            </div>
          )}
          {topActiveOption === "Physical Terminals" ? (
            <div
              // onClick={() => {
              //   console.log(requestDetails);
              // }}
              className="physical-card"
            >
              <div className="physical-card-top">
                {/* step one start */}
                {step === 1 && (
                  <>
                    <div className="terminal-bankbox-image-box-wrapper">
                      <div className="terminal-bankbox-image-box"></div>
                    </div>

                    <div className="terminal-request-input-fields-wrap">
                      <p className="select-a-quantity-tag">Select a quantity</p>
                      <QuantitySelector
                        quantity={requestDetails.quantity}
                        setQuantity={(newQuantity: number) => {
                          setRequestDetails((prev: any) => ({
                            ...prev,
                            quantity: newQuantity,
                          }));
                          // if (activeOption === "Deliver To Me") {
                          //   setRequestDetails((prev: any) => ({
                          //     ...prev,
                          //     quantity: newQuantity,
                          //   }));
                          // } else {
                          //   setPickupRequestDetails((prev) => ({
                          //     ...prev,
                          //     quantity: newQuantity,
                          //   }));
                          // }
                        }}
                      />
                      {requestDetails?.pricePerOne > 0 && (
                        <RavenBadge
                          style={{
                            backgroundColor: "var(--primary-base-color)",
                            color: "#ffffff",
                          }}
                          className="format-raven-badge"
                          // type="info"
                          text={``}
                        >{`Terminal Price: ${RavenNumberFormat(
                          requestDetails?.quantity *
                            actionCtx?.configDetails?.partnerInfo?.device_price
                        )}`}</RavenBadge>
                      )}
                    </div>
                  </>
                )}
                {/* step one end */}

                {/* step 2 start --------- */}
                {step === 2 && (
                  <>
                    <div className="terminal-request-input-fields-wrap">
                      <p className="select-a-quantity-tag">
                        Select delivery method{" "}
                      </p>

                      <SwitchBox
                        active={activeOption}
                        setActive={(param) => {
                          // console.log(param);
                          setRequestDetails((prev: any) => {
                            return {
                              ...prev,
                              city: "",
                              state: "",
                              streetAddress: "",
                              deliveryPickupId: "",
                              deliveryMethod: param,
                            };
                          });
                          setActivePickup("");
                          setActiveOption(param);
                        }}
                        // setActive={setActiveOption}
                        options={switchOptions}
                      />

                      <div
                        // onClick={() => {
                        //   console.log(pickup_locations);
                        // }}
                        className="input-boxes-holder-container"
                      >
                        {activeOption === switchOptions[0] ? (
                          <div className="the-input-tags">
                            <form
                              autoComplete="off"
                              style={{ width: "100%", padding: "0rem .1rem" }}
                              action=""
                            >
                              <RavenInputField
                                menuPlacement={`bottom`}
                                color="deep-green-light"
                                label="State"
                                type="select"
                                placeholder="Select option"
                                value={requestDetails?.state}
                                onChange={(e: any) => {
                                  setRequestDetails((prev: any) => {
                                    return { ...prev, state: e, city: "" };
                                  });
                                  handleGetLgas(e);
                                }}
                                selectStyles={reactSelectStyle}
                                selectOption={formatState(regions)}
                              />
                            </form>
                            <form
                              autoComplete="off"
                              style={{ width: "100%", padding: "0rem .1rem" }}
                              action=""
                            >
                              <RavenInputField
                                menuPlacement={`bottom`}
                                selectStyles={reactSelectStyle}
                                color="deep-green-light"
                                label="City"
                                type="select"
                                labelSpanText={
                                  loading_reciept ? (
                                    <>
                                      <div
                                        style={{
                                          padding: "0rem",
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          transform: "translateX(1.5rem)",
                                        }}
                                        className="load-wrap"
                                      >
                                        <ThreeDots
                                          height="10"
                                          width="80"
                                          radius="9"
                                          // color="#020202"
                                          ariaLabel="three-dots-loading"
                                          wrapperStyle={{}}
                                          visible={true}
                                        />
                                      </div>
                                    </>
                                  ) : (
                                    ("" as any)
                                  )
                                }
                                placeholder="Select option"
                                value={requestDetails?.city}
                                disabled={!requestDetails?.state}
                                onChange={(e: any) => {
                                  setRequestDetails((prev: any) => {
                                    return { ...prev, city: e };
                                  });
                                }}
                                selectOption={formatState(
                                  local_governmen_areas
                                )}
                              />
                            </form>
                            <RavenInputField
                              color="deep-green-light"
                              disabled={false}
                              placeholder="Street Address"
                              value={requestDetails.streetAddress}
                              label="Street Address"
                              className="address-input-field"
                              onChange={(e: any) => {
                                setRequestDetails((prev: any) => ({
                                  ...prev,
                                  streetAddress: e.target.value,
                                }));
                              }}
                            />
                          </div>
                        ) : (
                          <>
                            {" "}
                            <div className="location-inbox-holder-container">
                              {pickup_locations?.map(
                                (item: any, index: any) => {
                                  const uniqueId = `${item?.id}-${item?.address}`;
                                  return (
                                    <div
                                      key={index}
                                      className={`location-conten-box-wrap grey-bg  border-theme ${
                                        activePickUp === uniqueId
                                          ? "active"
                                          : ""
                                      }`}
                                      onClick={() => {
                                        activePickUp === uniqueId
                                          ? setActivePickup("")
                                          : setActivePickup(uniqueId);
                                        setRequestDetails((prev: any) => {
                                          return {
                                            ...prev,
                                            deliveryPickupId: item?.id,
                                            state: {
                                              label: item?.state,
                                              value: item?.state,
                                            },
                                            streetAddress: item?.address,
                                            city: {
                                              label: item?.lga,
                                              value: item?.lga,
                                            },
                                            days: sortDaysToString(
                                              item?.pick_up_days
                                            ),
                                          };
                                        });
                                      }}
                                    >
                                      {/* selected box here */}
                                      {activePickUp === uniqueId && (
                                        <div className="selected-box-wrap-check">
                                          <RavenRadioCheck
                                            color="deep-green-light"
                                            checked={true}
                                            onChange={() => {}}
                                          />
                                        </div>
                                      )}
                                      {/* selected box end */}
                                      {loading_reciept ? (
                                        <Skeleton
                                          width={70}
                                          height={17}
                                          style={{ marginBottom: ".3rem" }}
                                        />
                                      ) : (
                                        <p
                                          style={{ width: "95%" }}
                                          className="location-address-box grey-white-color-white"
                                        >
                                          {`Pickup Address: ${item.address} ${item.lga}, ${item.state}.`}
                                        </p>
                                      )}
                                      {loading_reciept ? (
                                        <Skeleton
                                          width={70}
                                          height={17}
                                          style={{ marginBottom: ".3rem" }}
                                        />
                                      ) : (
                                        <p className="location-time-box  grey-white-color-white ">
                                          {`Pickup Time: ${item?.start_time} - ${item.stop_time}`}
                                        </p>
                                      )}
                                      {loading_reciept ? (
                                        <Skeleton
                                          width={70}
                                          height={20}
                                          style={{ marginBottom: ".3rem" }}
                                        />
                                      ) : (
                                        <>
                                          {item?.pick_up_days?.length > 0 && (
                                            <div className="loacation-days-box black-white-color-white card-bg ">
                                              {sortDays(
                                                item?.pick_up_days
                                              )?.map((day: any, id: any) => (
                                                <p
                                                  key={id}
                                                  className="day-of-days grey-white-color-white grey-bg"
                                                >
                                                  {day}
                                                </p>
                                              ))}
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </div>
                                  );
                                }
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </>
                )}
                {/* step 2 end */}
                {/* step 3 start ----- */}
                {step === 3 && (
                  <>
                    <RequestTerminalPreview
                      details={{ ...requestDetails, type: topActiveOption }}
                    />
                  </>
                )}
                {/* step 3 end -------- */}
              </div>
            </div>
          ) : (
            <div className="virtual-terminals">
              <div className="virtual-terminals-inner">
                {step === 1 && (
                  <>
                    <div className="virtual-terminal-top-content-image-box "></div>{" "}
                    <div className="virtual-bottom-box">
                      <p className="virtual-terminal-header">
                        Virtual Terminal
                      </p>
                      <div className="virtual-terminal-price-and-fees-box grey-bg ">
                        <div className="virtual-terminal-price-box">
                          <div className="virtual-terminal-price-and-icon-box grey-white-color-white">
                            <div className="icon-box-wrap">
                              <figure className="img-box">{Icons.naira}</figure>
                            </div>
                            <p className="terminal-price-box  grey-white-color-white">
                              Terminal price
                            </p>
                          </div>
                          <p className="fee-box  grey-white-color-white">
                            Free
                          </p>
                        </div>
                        <div
                          className="virtual-terminal-price-box"
                          style={{ borderTop: "0.10rem solid #EEEEEE" }}
                        >
                          <div className="virtual-terminal-price-and-icon-box">
                            <div className="icon-box-wrap">
                              <figure className="img-box">
                                {Icons.transactionFee}
                              </figure>
                            </div>
                            <p className="terminal-price-box grey-white-color-white">
                              Transaction fees
                            </p>
                          </div>
                          <p className="fee-box  grey-white-color-white">
                            1.5%
                          </p>
                        </div>
                      </div>
                      <p className="virtual-terminal-header">Features</p>
                      <div className="virtual-terminal-prifeatures-box grey-bg">
                        {featuresObject.map((item, index) => (
                          <div className="features-box-wrap-box">
                            <div className="virtual-terminal-price-and-icon-box ">
                              <div className="icon-box-wrap">
                                <figure className="img-box">{item.icon}</figure>
                              </div>
                            </div>
                            <div className="virtual-terminal-header-and-text-box">
                              <p className="header-text-box  grey-white-color-white">
                                {item.header}
                              </p>
                              <p className="text-text-text-box  grey-white-color-white">
                                {item.text}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                )}
                {/* step 1 virtual end ------------ */}
                {step === 2 && (
                  <>
                    <div className="virtual-terminal-top-content-image-box "></div>{" "}
                    <div className="virtual-terminal-fill-view-box">
                      <RavenInputField
                        value={virtualTerminaldetails.terminalLabel}
                        color="deep-green-light"
                        label="Terminal label * "
                        placeholder="e.g Cargo Stores"
                        onChange={(e: any) =>
                          setVirtualTerminalDetails((prev: any) => ({
                            ...prev,
                            terminalLabel: e.target.value,
                          }))
                        }
                      />
                      <div className="prefered-account-type">
                        <RavenInputField
                          value={virtualTerminaldetails.accountNo}
                          onChange={(e: any) =>
                            setVirtualTerminalDetails((prev: any) => ({
                              ...prev,
                              accountNo: e.target.value,
                            }))
                          }
                          name="accountNo"
                          maxLength={10}
                          color="deep-green-light"
                          label={
                            loading_reciept
                              ? "Generate account number"
                              : "Enter your preferred account no. or generate "
                          }
                          type="account-number"
                          placeholder="e.g 0121559651"
                          labelSpanText={
                            loading_reciept ? (
                              <>
                                <div
                                  style={{
                                    padding: "0rem",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    transform: "translateX(1.5rem)",
                                  }}
                                  className="load-wrap"
                                >
                                  <ThreeDots
                                    height="10"
                                    width="80"
                                    radius="9"
                                    // color="#020202"
                                    ariaLabel="three-dots-loading"
                                    wrapperStyle={{}}
                                    visible={true}
                                  />
                                </div>
                              </>
                            ) : (
                              ("" as any)
                            )
                          }
                        />

                        <div
                          className="generate-box grey-bg"
                          onClick={() => {
                            if (!loading_reciept) {
                              handleGenerateAccountNumber();
                            }
                          }}
                        >
                          <figure className="img-box">
                            {Icons.generateAccount}
                          </figure>
                        </div>
                      </div>

                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                        }}
                        action=""
                        className="form"
                        style={{
                          width: "100%",
                          position: "relative",
                          zIndex: "20",
                          padding: "0rem .1rem",
                        }}
                      >
                        <RavenInputField
                          menuPlacement={`top`}
                          onChange={(e: any) => {
                            setVirtualTerminalDetails((prev: any) => {
                              return { ...prev, purpose: e };
                            });
                          }}
                          color="deep-green-light"
                          label="Purpose of request * "
                          type="select"
                          value={virtualTerminaldetails?.purpose}
                          placeholder="Select option"
                          selectOption={formatState(purposeOfrequest)}
                          selectStyles={reactSelectStyle}
                        />
                      </form>
                    </div>
                  </>
                )}
                {/* step 2 virtual end ------------ */}
                {/* step 3 start ----- */}
                {step === 3 && (
                  <>
                    <RequestVirtualTerminalPreview
                      details={{
                        ...virtualTerminaldetails,
                        type: topActiveOption,
                      }}
                    />
                  </>
                )}
                {/* step 3 end -------- */}
              </div>
              {/* <div className="btn-box border-theme-top card-bg">
                <RavenButton
                  color="deep-green-light"
                  label={
                    createVirtualTerminalSteps === "fill"
                      ? "Continue"
                      : "Create Virtual Terminal"
                  }
                  className="raven-submit-button"
                  disabled={handleVirtualDisable()}
                  onClick={() => {
                    if (createVirtualTerminalSteps === "fill") {
                      navigate(RouteLinks?.Request_Virtual_Terminal_display, {
                        state: virtualTerminaldetails,
                      });
                    }
                    handleNextStep();
                  }}
                />
              </div> */}
            </div>
          )}
        </div>
      </ContainerWrapper>
    </DashboardLayout>
  );
};

export default RequestTerminal;
